import { Dimensions } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import Constants from "expo-constants"

const { platform } = Constants.expoConfig.extra

console.log({ baseStylesPlateforme: platform })
const isCpts = platform === "cpts"
const dimensions = {
    fullHeight: Dimensions.get("window").height,
    fullWidth: Dimensions.get("window").width
}

const cptsBaseColors = {
    green: {
        primary: "#0087CB",
        secondary: "#92bbe1",
        dark: "#015E8D",
        pastel: "#92BBE1",
        light: "rgba(217, 232, 246, 0.3)"
    },
    orange: {
        primary: "#CA5353",
        secondary: "#424242",
        flash: "#FF821F",
        dark: "#8D3A3A",
        light: "#FFF9F5"
    },
    white: "#FFFFFF",
    black: "#424242",
    grey: "#BFC8C9",
    textBlack: "#0D4447"
}

const soignantBaseColors = {
    green: {
        primary: "#3EABAB",
        secondary: "#5BB8B8",
        dark: "#1B8E95",
        pastel: "#64C7C7",
        light: "#E6F4F4"
    },
    orange: {
        primary: "#F39041",
        secondary: "#F5A15D",
        flash: "#FF821F",
        dark: "#EB6800",
        light: "#FFF9F5"
    },
    white: "#FFFFFF",
    black: "#0D4447",
    grey: "#BFC8C9"
}

const baseColors = isCpts ? cptsBaseColors : soignantBaseColors

const basePadding = {
    paddingHorizontal: 18,
    paddingVertical: 18
}

const baseMarging = {
    marginVertical: 50,
    marginHorizontal: 50,
    marginBottom: 18
}

const baseFontSize = {
    sm: RFValue(12),
    md: RFValue(18),
    lg: RFValue(28)
}

const baseFontFamily = {
    OpenSans: "OpenSans",
    OpenSansRegular: "OpenSansRegular",
    OpenSansSemiBold: "OpenSansSemiBold",
    OpenSansBold: "OpenSansBold",
    BreeSerif: "BreeSerif"
}

export { dimensions, baseColors, basePadding, baseMarging, baseFontSize, baseFontFamily }
